import util from '../util'

let controller = 'BaixaEfetiva'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post']))